<template>
	<q-page padding>
		<div class="row justify-center">
			<div class="col-xs-12 col-sm-12 col-md-8 col-lg-4">
				<q-card class="q-py-xl bg-white">
					<q-card-title class="text-center login-form">
						<img :src="login_logo" />
					</q-card-title>

					<q-card-separator />

					<q-card-main>
						<q-field :helper="$t(getPasswordHelper)" :error="$v.user_password.$error">
							<q-input
								v-model="user_password"
								:float-label="$t('password')"
								type="password"
								:error="$v.user_password.$error"
								@input="$v.user_password.$touch"
							/>
						</q-field>

						<q-input
							v-model="user_password_confirmation"
							:float-label="$t('confirm_password')"
							type="password"
							@keyup.enter.native="setNewPassword()"
							:error="$v.user_password_confirmation.$error"
							@input="$v.user_password_confirmation.$touch"
						/>

						<q-btn
							color="primary"
							class="full-width q-mt-md"
							icon="fal fa-key"
							:label="$t(getLabelButton)"
							@click="setNewPassword()"
						/>
					</q-card-main>

					<q-card-separator />

					<q-card-actions>
						<q-btn
							color="tertiary"
							class="full-width q-my-sm"
							icon="fas fa-chevron-left"
							:label="$t('back')"
							@click="$router.push({ name: 'login' })"
						/>
					</q-card-actions>
				</q-card>
			</div>
		</div>

		<q-dialog v-model="show_error" @ok="show_error = false" :cancel="false">
			<span slot="title">{{ $t('set_password_error') }}</span>

			<span slot="message">{{ $t('set_new_password_invalid_information') }}</span>
		</q-dialog>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import passwordComplexity from '../../functions/validate-password'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'login'] },

	data() {
		return {
			user_password: '',
			user_password_confirmation: '',
			uidb64: '',
			token: '',
			show_error: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			login_logo: 'params/login_logo',
			clients: 'params/clients',
			password_strong_level: 'params/password_strong_level',
		}),

		getHeaderJson() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
				},
			})
		},

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/x-www-form-urlencoded',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
				},
			})
		},

		getAuthHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getLabelButton() {
			if (this.$route.name === 'set-new-password') {
				return 'change_password'
			} else if (this.$route.name === 'set-password') {
				return 'set_password'
			}
		},

		getPasswordHelper() {
			if (this.password_strong_level == 'strong') {
				return 'helper_password_strong'
			} else if (this.password_strong_level == 'medium') {
				return 'helper_password_medium'
			} else {
				return 'helper_password_low'
			}
		},
	},

	methods: {
		setNewPassword() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()

				let fd = new FormData()
				fd.append('user_password', this.user_password)
				fd.append('user_password_confirmation', this.user_password_confirmation)

				this.$axios
					.post(`/api_change_password/${this.uidb64}/${this.token}/`, fd, this.getHeader)
					.then((response) => {
						this.login()
					})
					.catch((e) => {
						this.$q.loading.hide()
						this.show_error = true
						console.log(e)
					})
			}
		},

		login() {
			let data = {
				grant_type: 'password',
				username: this.username,
				password: this.user_password,
			}

			this.$axios
				.post('/o/token/', this.$qs.stringify(data), this.getHeader)
				.then((response) => {
					this.$store.dispatch('common/SET_ACCESS_TOKEN', [
						response.data.access_token,
						response.data.refresh_token,
						response.data.user_firebase_token,
					])

					if (response.data.user_firebase_token) {
						firebase
							.auth()
							.signInWithCustomToken(response.data.user_firebase_token)
							.then(() => {
								if (this.$q.platform.is.cordova) {
									this.setUserDeviceToken()
								} else {
									this.getWelcomeBanner()
								}
							})
							.catch(function(error) {
								var errorCode = error.code
								var errorMessage = error.message
							})
					} else {
						if (this.$q.platform.is.cordova) {
							this.setUserDeviceToken()
						} else {
							this.getWelcomeBanner()
						}
					}
				})
				.catch((e) => {
					this.$q.loading.hide()
					this.show_error = true
					console.log(e)
				})
		},

		setUserDeviceToken() {
			// window.plugins.OneSignal.getIds((ids) => {
			//     let fd = new FormData()
			//     fd.append('token', ids.userId)
			//     fd.append('device_type', this.$q.platform.is.android ? 'android' : 'ios')

			//     this.$axios.post('/etraining_login/set_user_device_token', fd, this.getAuthHeader)
			//     .then(response => {
			this.getWelcomeBanner()
			//     })
			//     .catch(e => {
			//         this.getWelcomeBanner()
			//         console.log(e)
			//     })
			// })
		},

		getWelcomeBanner() {
			this.$axios
				.get('/etraining_banners_welcome/banners_welcome/', this.getAuthHeader)
				.then((response) => {
					this.$store.dispatch('welcome_banner/SET_WELCOME_BANNER', [response.data])
					this.getUserData()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		getUserData() {
			this.$axios
				.get('/accounts/read_user_data/', this.getAuthHeader)
				.then((response) => {
					const d = response.data

					this.$store.dispatch('common/SET_USER_DATA', [
						d.id,
						d.id_user_client_profile,
						d.full_name,
						d.document,
						d.id_user_client_selected,
						d.id_user_client_country_selected,
						d.id_user_language_selected,
						d.user_clients,
						d.user_client_module_items,
						d.user_firebase_document,
						d.is_superuser,
						d.email,
						d.user_firebase_document_ranking_areas,
						d.has_mandatory_surveys,
						d.accept_terms_and_conditions,
						d.user_companies,
						d.user_branches,
					])

					const obj = this.clients.find(
						(obj) => obj.id === response.data.id_user_client_selected
					)
					if (obj) {
						if (obj.home_route) {
							this.$router.replace({ name: obj.home_route })
						} else {
							if (obj.has_courses) {
								this.$router.replace({ name: 'courses' })
							} else if (obj.has_trails) {
								this.$router.replace({ name: 'trails' })
							} else if (obj.has_library) {
								this.$router.replace({ name: 'library' })
							} else if (obj.has_webcasts) {
								this.$router.replace({ name: 'webcasts' })
							}
						}
					} else {
						this.$router.replace({ name: 'courses' })
					}
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		validPassword() {
			let strongRegex = new RegExp(
				'^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})'
			)
			let mediumRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})')
			let low = new RegExp('^(?=.{6,})')

			if (this.password_strong_level == 'strong') {
				return strongRegex.test(this.user_password)
			} else if (this.password_strong_level == 'medium') {
				return mediumRegex.test(this.user_password)
			} else {
				return low.test(this.user_password)
			}
		},
	},

	validations() {
		return {
			user_password: {
				required,
				validPassword() {
					return this.validPassword()
				},
			},
			user_password_confirmation: {
				sameAsPassword: sameAs('user_password'),
			},
		}
	},

	created() {
		this.uidb64 = this.$route.params.uidb64
		this.token = this.$route.params.token
		this.username = this.$route.params.username
		if (!this.uidb64 || !this.token || !this.username) this.$router.push({ name: 'login' })
	},
}
</script>

<style lang="stylus" scoped>
.login-form
    & img
        max-width 100%
</style>
